export type MyStoreOrderTabsType =
  | 'pending_approval'
  | 'supplying'
  | 'delivered'
  | 'canceled';
export type OrderStepsNumber = 1 | 2 | 3 | 4;

export const storeOrderTabsConfig: Array<{
  key: MyStoreOrderTabsType;
  label: string;
  step: OrderStepsNumber;
}> = [
  {key: 'pending_approval', label: 'در انتظار تایید', step: 1},
  {key: 'supplying', label: 'در حال تامین', step: 2},
  {key: 'delivered', label: 'تحویل داده شده', step: 3},
  {key: 'canceled', label: 'لغوشده', step: 4},
];
